var map = {
	"./backdrop": 54,
	"./backdrop.jpg": 54,
	"./company-placeholder": 55,
	"./company-placeholder.svg": 55,
	"./news-placeholder": 56,
	"./news-placeholder.svg": 56,
	"./swissrail-logo": 57,
	"./swissrail-logo.svg": 57,
	"./user-placeholder": 58,
	"./user-placeholder.svg": 58,
	"./video-icon": 59,
	"./video-icon.svg": 59
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;